import { useQuery } from "@tanstack/react-query";
import queryString from "query-string";

import { DefaultFetchService } from "app/services/fetchService";

interface IUseCompareDataQueryParams {
    api: string;
    queryParamsForCompareTabs: unknown;
    requestBody?: unknown;
    enabled: boolean;
}

export const useCompareDataQuery = ({
    api,
    queryParamsForCompareTabs,
    requestBody,
    enabled,
}: IUseCompareDataQueryParams) => {
    const fetchService = DefaultFetchService.getInstance();

    return useQuery<Record<string, number>>({
        queryKey: [api, queryParamsForCompareTabs, requestBody],
        queryFn: async () => {
            let response: Record<string, number>;
            if (requestBody) {
                response = await fetchService.post<Record<string, number>>(
                    `${api}?${queryString.stringify(queryParamsForCompareTabs)}`,
                    requestBody,
                );
            } else {
                response = await fetchService.get(api, queryParamsForCompareTabs);
            }
            return response;
        },
        enabled,
    });
};
